var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "more-content" }, [
    _c(
      "ul",
      _vm._l(_vm.list, function(item, index) {
        return _c("li", { key: index }, [
          _c("a", { attrs: { href: _vm.calcPath(item.path) } }, [
            _c("h4", [_vm._v(_vm._s(item.title))]),
            _vm._v(" "),
            _c("img", { attrs: { src: item.img, alt: item.title } })
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }